import Vue from 'vue';
import VueResource from 'vue-resource';
Vue.use(VueResource);

export default {
    async downloadFile(context, { fileUrl, fileName }) {
        try {
            let response = await fetch(fileUrl);
            let blob = await response.blob();
            let urlObjet = window.URL.createObjectURL(blob);
            let lienTelechargement = document.createElement('a');
            lienTelechargement.href = urlObjet;
            lienTelechargement.download = fileName;
            document.body.appendChild(lienTelechargement);
            lienTelechargement.click();
            document.body.removeChild(lienTelechargement);

            // Révoquer l'URL objet pour libérer des ressources
            window.URL.revokeObjectURL(urlObjet);
        } catch (error) {
            console.error('Erreur lors du téléchargement du fichier :', error);
        }
    },
    fetchTotalSiteConsumptionPercent(context, { url }) {
        return context.dispatch('remoteGet', {
            url: url,
        }).then(res => {
            return res.data.results[0].total_site_consumption_percent;
        }).catch(error => {
            console.error('Erreur lors de la récupération du pourcentage de consommation totale du site :', error);
        });

    },
    async resetSimulationData(context, { item, itemType, declarationUpdated }) {

        if (declarationUpdated) {
            let dataToPost = {
                ...item,
            };
            dataToPost.simulation_measure_uid = null;
            await context.dispatch('patchItem', {
                item: dataToPost,
                model: itemType,
                uid: dataToPost.uid,
                url: dataToPost.url
            })
        }
        await context.dispatch('patchItem', {
            item: {
                pptx_status: 'PENDING',
                simulation_status: 'PENDING',
                uid: context.getters.currentSite.uid,
                url: context.getters.currentSite.url
            },
            model: 'site',
            uid: context.getters.currentSite.uid,
            url: context.getters.currentSite.url
        }).catch(error => {
            console.error('Erreur lors de la réinitialisation du statut de la génération du rapport :', error);
        });
        if (!context.getters.currentSimulation) {
            return;
        }
        let dataToPost = {
            ...context.getters.currentSimulation,
        };
        context.commit('SET_CURRENT_SIMULATION', null);
        dataToPost.status = 'OUTDATED';
        dataToPost.archived = true;
        delete dataToPost.pptx_file;

        await context.dispatch('patchItem', {
            item: dataToPost,
            model: 'simulations',
            uid: dataToPost.uid,
            url: dataToPost.url
        }).then(() => {

        }).catch(error => {
            console.error('Erreur lors de la réinitialisation des données de la simulation :', error);
        });
    }
};



// WEBPACK FOOTER //
// ./src/store/actions.js